/* eslint-disable camelcase */

import { AssistantStatus } from '@src/types/assistant';

export type BusinessTimePerDay = { from: number; to: number };

export type BusinessTimePerWeek = BusinessTimePerDay[][];

export type DayOfWeekValue = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export type BusinessTimePerHoliday = {
  date: Date;
  businessTimeInterval?: BusinessTimePerDay[];
};
export type BusinessTimePerHolidays = BusinessTimePerHoliday[];

export type BusinessTimeAssistant = {
  id: string;
  name: string;
  status: AssistantStatus;
};

export type BusinessTime = {
  timesPerWeekDay?: BusinessTimePerWeek;
  timesPerHoliDay: BusinessTimePerHolidays;
  merchantAvailability?: {
    receivedChatsNoAvailability: boolean;
    agentPriority?: BusinessTimeAgentPriority;
  };
  assistants?: BusinessTimeAssistant[];
  noAgentsAvailableMessage?: {
    enabled: boolean;
    value: string;
  };
};

// eslint-disable-next-line no-shadow
export enum BusinessTimeAgentPriority {
  HUMAN_AGENT = 'HUMAN_AGENT',
  AI_AGENT = 'AI_AGENT',
}
